import {AxiosError} from 'axios';

import {IUploadDataWithTokenArgs} from 'features/provide-custom-link/api/types';
import {ERequestType} from 'shared/types/requests';
import {performRequest, showMessage, showMessageFromResponse} from 'shared/utils';

/**
 * Запрос отправляет данные с token для микросервиса
 *
 * @param {ELinkMethod | null} method - Метод для запроса
 * @param {string} urlWithParams - URL с подставленными параметрами в query-строке
 * @param {string | null} token - Токен для микросервиса
 * @param {string | null} bodyType - Content-Type для тела запроса
 * @param {boolean | null} suppressMessages - Нужно ли скрывать оповещение о результате запроса
 * @param {TStateSetter<boolean>} setLoading - Сеттер для обновления статуса загрузки
 * @param {TLinkParameters | null} resolvedBodyParameters - Параметры для тела запроса
 *
 */
export const uploadDataWithToken = async ({
    method,
    urlWithParams,
    token,
    bodyType,
    suppressMessages,
    setLoading,
    resolvedBodyParameters,
}: IUploadDataWithTokenArgs) => {
    try {
        const response = await performRequest({
            method: method ?? ERequestType.GET,
            url: urlWithParams,
            headers: {
                Authorization: token,
                'Content-Type': bodyType ?? 'application/json',
            },
            data: resolvedBodyParameters,
        });

        if (!suppressMessages) showMessageFromResponse({response});
    } catch (e) {
        const error = e as AxiosError;

        if (error.message === 'Network Error') {
            showMessage({
                message: 'Ошибка сети',
                description: 'Проверьте подключение к интернету или доступность сервера',
                isError: true,
            });
            return;
        }

        if (error.response?.status === 502) {
            showMessage({
                message: 'Не удалось подключиться к микросервису',
                description: 'Проверьте доступность сервиса или повторите попытку позже',
                isError: true,
            });
            return;
        }

        if (!suppressMessages) {
            showMessageFromResponse({
                response: error.response,
                isError: true,
            });
            return;
        }
    } finally {
        setLoading?.(false);
    }
};
